import { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { completeOrReschedulePayment, getRecords } from 'src/api';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';
import { getPendingPayments } from 'src/api/admin/records';
import RegisterPaymentModal from 'src/pages/MemberList/MemberModals/registerPayment';
import dayjs from 'dayjs';

const PendingPayments = ({ data }) => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user ,gymId} = useSelector((state) => state.common);
  const [page, setPage] = useState(0);
  const headers = ['Name', 'Pending payment Months', 'Add Payment'];
  const [pendingPayments, setPendingPayments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [member, setMember] = useState({});

  const limit = 20;

  const handleModal = (member) => {
    setMember(member);
    setOpenModal((prev) => !prev);
  };

  useEffect(() => {
    dispatch(startLoading());
    getPendingPayments(user,gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS)
          console.log(res.data);
        setPendingPayments(res.data);
      })
      .catch((err) => console.log(err, 'ERR'))
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PerfectScrollbar>
        <RegisterPaymentModal
          open={openModal}
          setOpen={handleModal}
          member={member}
        />
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pendingPayments.length > 0 &&
                pendingPayments.map((dataItem, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{dataItem.full_name}</TableCell>
                    <TableCell>{dayjs(new Date()).format('MM-YYYY')}</TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        size="medium"
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          handleModal(dataItem);
                        }}
                      >
                        {STRINGS.ADD_PAYMENT}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
    </>
  );
};

export default PendingPayments;
